import { render, staticRenderFns } from "./GeneralFeedbackModal.vue?vue&type=template&id=ea59222a&scoped=true&"
import script from "./GeneralFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./GeneralFeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./GeneralFeedbackModal.vue?vue&type=style&index=0&id=ea59222a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea59222a",
  null
  
)

export default component.exports